<template>
  <div class="box-con-reco">
    <div class="hd z-flex z-flex-between">
      <div class="hd-l">相关影展推荐</div>
      <el-button class="btn-refresh" type="text" @click="refresh">
       <i class="el-icon-refresh el-icon--left"></i>换一批
      </el-button>
    </div>
    <div class="bd">
      <exhibitionItem :itemData="item" v-for="(item, index) in recoList" :key="index"></exhibitionItem>
    </div>
  </div>
</template>

<script>
import exhibitionItem from '@/components/item/exhibitionItem';
export default {
  components: {
    exhibitionItem,
  },
  name: "recoCaifeng",
  props: {
    
  },
  data() {
    return {
      recoList:[],
    };
  },
  mounted() {
    this.getRecommendList();
  },
  methods: {
    toUrl(url){
      this.$router.push({
        path:url,
      })
    },
    //换一批
    refresh(){
      this.getRecommendList();
    },
    getRecommendList(){
      this.$axios.api.request({
        url: "/api/qtclub/exhibition/getRecommendList",
        method: "GET",
        data: {
          length: 2,
        }
      }, (res) => {
        this.recoList = res.data.list;
      })
    }
  },
};
</script>

<style lang="scss" scoped>
.box-con-reco{
  .bd{
    ::v-deep .match-item{
      height:245px;
      margin:20px 0;
      .img-wrap{
        height:150px;
      }
    }
  }
}
</style>
